import { Route, Routes, useLocation } from 'react-router-dom';
import { ProfilePage } from './ProfilePage/ProfilePage';
import { QuizThemesPage } from './QuizThemesPage/QuizThemesPage';
import { QuizQuestionPage } from './QuizQuestionPage/QuizQuestionPage';
import { useDispatch, useSelector } from '../../hooks';
import { useContextNavigate } from '../../hooks/navigate';
import { useCallback, useEffect } from 'react';
import { getQuiz } from '../../redux/quizzes/get-quiz.handler';
import { getTasks } from '../../redux/tasks/get-tasks.handler';
import { updateProfile } from '../../redux/profile';
import { AppContext } from '../../components/Menu/MenuButton';

export enum QuizContext {
    Profile = 'profile',
    Themes = 'themes',
    Question = 'question',
}

export const QuizRoutes = () => {
    const dispatch = useDispatch();
    const navigate = useContextNavigate<QuizContext>();
    const location = useLocation();

    const quiz = useSelector(store => store.quiz.quiz);

    const fetchQuiz = useCallback(async () => {
        const resultAction = await dispatch(getQuiz());
        if (getQuiz.fulfilled.match(resultAction)) {
            const profile = resultAction.payload?.profile;
            if (profile !== undefined)
                dispatch(updateProfile(profile));
        }
    }, [dispatch]);

    useEffect(() => {
        dispatch(getTasks());
    }, [dispatch]);

    useEffect(() => {
        if (!quiz)
            fetchQuiz();
    }, [fetchQuiz, quiz]);

    useEffect(() => {
        if (location.pathname === `/${AppContext.Quiz}`)
            navigate(QuizContext.Themes, { replace: true });

        const isNavigated = (quizContext: QuizContext) => location.pathname === `/${AppContext.Quiz}/${quizContext}`;

        if (quiz) {
            if (!isNavigated(QuizContext.Question))
                navigate(QuizContext.Question, { replace: true });
            return;
        }
    }, [navigate, location, quiz]);

    return (
        <Routes>
            <Route path={`/${QuizContext.Themes}`} element={<QuizThemesPage />} />
            <Route path={`/${QuizContext.Profile}`} element={ <ProfilePage /> } />
            <Route path={`/${QuizContext.Question}`} element={ <QuizQuestionPage /> } />
        </Routes>
    );
};